// Pure display helpers for ShipmentCard (kept out of the .jsx so node --test can cover them).

export function formatCarrierDelay(v) {
  const n = Number(v);
  if (Number.isNaN(n) || n === 0) return null;
  const body = Number.isInteger(n) ? String(Math.abs(n)) : Math.abs(n).toFixed(1);
  return n > 0 ? `+${body}d` : `−${body}d`;
}

// Bar fill: red when >= 1 day late, darker green when >= 1 day early, else green.
export const delayBarColor = (delayDays) => {
  const n = Number(delayDays);
  if (delayDays != null && delayDays !== '' && !Number.isNaN(n)) {
    if (n >= 1) return '#f87171';
    if (n <= -1) return '#16a34a';
  }
  return '#22c55e';
};

// Card-level "Weight per variety" shows only when the voyage-stops accordion
// does not render; otherwise the variety detail lives once inside the port group.
export function showCardLevelWeight({ showStopsAccordion, hasWeightGroups }) {
  return !showStopsAccordion && Boolean(hasWeightGroups);
}
